var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 pa-0 optimization-response-chart-wrapper"},[_c('v-col',{staticClass:"ma-0 pa-0 optimization-response-chart-cell",attrs:{"cols":"12"}},[_c('v-chart',{staticClass:"optimization-response-chart",attrs:{"option":_vm.chartOption,"autoresize":""},on:{"click":_vm.handleChartClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }